import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import persistState from 'redux-localstorage';

import { ISessionState, sessionReducers } from '~/src/dash/reducers/session-reducers';
import { IUserState, userReducers } from '~/src/dash/reducers/user-reducers';
import { getStorage } from '~/src/dash/resellers/utils/importResellerConfig';

export interface IStore {
  user: IUserState;
  session: ISessionState;
}

export const store = createStore(
  combineReducers({
    user: userReducers,
    session: sessionReducers,
  } as any),
  compose(
    applyMiddleware(),
    persistState(undefined, {
      key: getStorage(),
      slicer() {
        return (state: IStore) => {
          return {
            user: state.user,
          };
        };
      },
    } as any),
  ),
);
